import React from 'react'
import { Base } from '../components'
import { WebPageStructuredData, PAGES } from '../utils'
import { BillboardWithImage } from '../shared/components/v2/BillboardWithImage/BillboardWithImage'
import {
  securityCardFreezeBillboardWithImageProps,
  securityFaqBlockData,
  securityHeroBillboardWithImageProps,
} from '../data/pages/security.data'
import { FaqBlock } from '../shared/components/v2/FaqBlock/FaqBlock'

const Security = (): JSX.Element => {
  const SECURITY = PAGES.SECURITY
  return (
    <Base
      headKey={SECURITY.HEAD_KEY}
      title={SECURITY.TITLE}
      metaDescription={SECURITY.DESCRIPTION}
      breadcrumbs={SECURITY.BREADCRUMBS}
    >
      <WebPageStructuredData
        name={SECURITY.TITLE}
        description={SECURITY.DESCRIPTION}
        path={SECURITY.PATH}
        breadcrumbs={SECURITY.BREADCRUMBS}
      />
      <BillboardWithImage {...securityHeroBillboardWithImageProps} />
      <BillboardWithImage {...securityCardFreezeBillboardWithImageProps} />
      <FaqBlock {...securityFaqBlockData} />
    </Base>
  )
}

export default Security
